import { compose, mdsWidget } from 'dojo/_base/declare';
import template from './create_projectCalendar.html?raw';

import _WidgetBaseSP from 'more/_WidgetBaseSP';
import GenericDialog from '../../../../../moreCore/UI/GenericDialog/GenericDialog';
import Edit from '../../../../../moreCore/UI/Edit/Edit';
import HintBox from '../../../../../moreCore/UI/HintBox/HintBox';
import lang from 'dojo/_base/lang';

class create_projectCalendar extends compose(_WidgetBaseSP) {
    templateString: any = template;

    private myDlg: MdsLax<InstanceType<typeof GenericDialog>> = null;

    private projectSelect:MdsLax<InstanceType<typeof HintBox>>;
    private editTabDisplayName:MdsLax<InstanceType<typeof Edit>>;

    private containerForEditDisplayName:HTMLDivElement;

    private value: { msTeamsChannelEntityId: string, displayName: string, projectEntityId: string, projectEntityClassname: string, tabID?:string } = { msTeamsChannelEntityId:null, displayName: null, projectEntityId: null, projectEntityClassname:null };
    postCreate(): void {
        super.postCreate.apply(this, arguments as any);

        this.editTabDisplayName.setLabel(this.translate("General_Label_Displayname"));
        this.editTabDisplayName.on("valueChange", lang.hitch(this, this._onChange_Value));

        //attirbute max len = 32, in teams api ist stand 2027-07 "unlimited", teams crashed aber wenn der string zu lang ist und ab 20 chars wird der title abgehakt mit "..."
        this.editTabDisplayName.setMaxLength(30);
        this.editTabDisplayName.setMinLength(1);

        this.projectSelect.setLabel(this.translate("General_Label_EvProject"));
        this.projectSelect.setCallfunction("Webtool_API_MS_Teams_Integration_AdminPanel__TabConf_HintBox_Projects_GetData");
        this.projectSelect.setLabelAttribute("gDisp_1");
        this.projectSelect.enableSelectEntityDialog(true);
        this.projectSelect.on("valueChange", lang.hitch(this, this._onChange_Value));
    }

    startup(): void {
        super.startup.apply(this, arguments as any);
    }

    public showAsDlg(msTeamsChannelEntityId: string, onSaveCallback?: Function,){
        this.value.msTeamsChannelEntityId = msTeamsChannelEntityId;
        if (this.myDlg != null){
            try{
                this.myDlg.destroy();
            }catch{}
        }
        this.myDlg = new GenericDialog();
        this.myDlg.setSize('smaller');
        this.myDlg.show(
            this,
            this.translate("MsTeamsIntegration_AdminPanel_TabConf_NewProjectCalendar"),
            null,
            null,
            'submitcancel',
            lang.hitch(this, async (btnId: number) => {
                let myVal = this.getValue();
                if (btnId != 1) {
                    //not save
                    return;
                }
                if (typeof onSaveCallback == 'function')
                {
                    onSaveCallback(myVal);
                }
            })
        );
        this.myDlg.disableButton('submit');
    }

    private _onChange_Value(){
        let displayName = this.editTabDisplayName.getValue();
        let entity = this.projectSelect.getValue("entity");
        let projectEntityId = entity?.ID;
        let projectEntityClassname = entity?.Classname;
        if (displayName == ""){
            displayName = null;
        }
        if (projectEntityId == null){
            projectEntityId = null;
        }
        this.value.displayName = displayName;
        this.value.projectEntityId = projectEntityId;
        this.value.projectEntityClassname = projectEntityClassname;

        if (this.myDlg != null){
            if ((displayName != null) && (projectEntityId != null) ){
                this.myDlg.enableButton('submit');
            }
            else{
                this.myDlg.disableButton('submit');
            }
        }
        this.emit("valueChange", this.value);
    }

    public getValue() {
        return this.value;
    }

    public async setUpEdit(entity: TeamsTabApiData) {
        this.value.tabID = entity.ID;
        this.StandbyStart();
        let displayNamePromise:Promise<any> = new Promise((resolve, reject) => {
            this.RequestManager.callfunction(
                "MS_Teams_Integration_AdminPanel__TabConf_HintBox_Projects_GetData_GetDisplayName",
                {
                    ID: entity.projectCalendar_keyFilterValue
                },
                lang.hitch(this, (result:any) => {
                    resolve(result);
                }),
                lang.hitch(this, (err) => {
                    console.error(err.Message);
                    this.showToast(err.Message, "fas fa-bug");
                    reject(err);
                })
            );
        });

        let promRes:{ID:string, gDisp_1:string};
        try{
            promRes = await displayNamePromise;
        }catch(e){
            console.error("error fetching displayname for project", e);
        }
        let displayName = promRes?.gDisp_1;
        displayName = displayName ?? "unknown";

        this.editTabDisplayName.setValue(entity.tabDisplayName, true);
        this.projectSelect.setValue({
            ID: entity.projectCalendar_keyFilterValue,
            gDisp_1: displayName
        }, true);
        this.StandbyStop();
    }

    public hideDisplayNameInput(isHidden:boolean=true){
        if (isHidden){
            this.containerForEditDisplayName.classList.add("w3-hide");
        }else{
            this.containerForEditDisplayName.classList.remove("w3-hide");
        }
    }
}

export default mdsWidget(create_projectCalendar);
